var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Button, Flex } from '@chakra-ui/react';
import React from 'react';
import ConfirmPopup from '../ConfirmPopup';
var variantStyles = {
    default: {
        flexDir: { base: 'column', md: 'row' },
        gap: { base: 'xs', md: 'sm' },
        mt: '2xl',
    },
    sticky: {
        position: 'sticky',
        bottom: 8,
        bgColor: 'white',
        w: 'max',
        p: 'lg',
        borderRadius: 'xl',
        borderWidth: '1px',
        borderColor: 'border.pure',
        ml: 'auto',
        gap: 'xs',
    },
};
var ActionButtons = function (_a) {
    var onCancel = _a.onCancel, onDelete = _a.onDelete, onSave = _a.onSave, isMobile = _a.isMobile, showDelete = _a.showDelete, isSubmitting = _a.isSubmitting, isDeleting = _a.isDeleting, isDisabled = _a.isDisabled, _b = _a.deleteButtonText, deleteButtonText = _b === void 0 ? 'Delete' : _b, _c = _a.positiveButtonText, positiveButtonText = _c === void 0 ? 'Save' : _c, _d = _a.negativeButtonText, negativeButtonText = _d === void 0 ? 'Cancel' : _d, hideSubmit = _a.hideSubmit, message = _a.message, positiveButtonProps = _a.positiveButtonProps, negativeButtonProps = _a.negativeButtonProps, _e = _a.PositiveButton, PositiveButton = _e === void 0 ? Button : _e, _f = _a.variant, variant = _f === void 0 ? 'default' : _f, props = __rest(_a, ["onCancel", "onDelete", "onSave", "isMobile", "showDelete", "isSubmitting", "isDeleting", "isDisabled", "deleteButtonText", "positiveButtonText", "negativeButtonText", "hideSubmit", "message", "positiveButtonProps", "negativeButtonProps", "PositiveButton", "variant"]);
    var DeleteButton = function (_a) {
        var onClick = _a.onClick;
        return (React.createElement(Button, { colorScheme: 'delete', isDisabled: isSubmitting, isLoading: isDeleting, minH: '10', variant: 'link', onClick: onClick }, deleteButtonText));
    };
    return (React.createElement(Flex, __assign({}, variantStyles[variant], props),
        showDelete && onDelete && (React.createElement(ConfirmPopup, { PreviewButton: DeleteButton, isMobile: isMobile, message: message, onConfirm: onDelete })),
        !!onCancel && (React.createElement(Button, __assign({ colorScheme: 'primary', isDisabled: isSubmitting || isDeleting, variant: 'outline', onClick: onCancel }, negativeButtonProps), negativeButtonText)),
        !hideSubmit && (React.createElement(PositiveButton, __assign({ isDisabled: isDisabled || isDeleting, isLoading: isSubmitting, variant: 'primary', onClick: onSave }, positiveButtonProps), positiveButtonText))));
};
export default ActionButtons;
//# sourceMappingURL=ActionButtons.js.map